/* eslint-disable react-hooks/exhaustive-deps */
import React, {
	useEffect,
	useState,
	useRef,
    useMemo,
} from "react";
import Loader from "../../../general/Loader";
import { request } from "../../../../utils/request";
import {
	formatCurrency,
	getLink,
	getVendedoresForDropdown,
	isVendedor,
	mensajeDeError,
	money,
	toast,
} from "../../../../utils/helpers";
import { useHistory } from "../../../../utils/router";
import { apiRequest } from "../../../../hooks/apiRequest";

import Create from "../../../Contactos/Create";
import Edit from "../../../Contactos/Edit";
import Modal from "../../../general/Modal";
import ProductosOrden from "./ProductosOrden";
import ProductosOrdenMobile from "./ProductosOrdenMobile";
import Detalles from "./Detalles";
import { auth } from "../../../../utils/auth";
import dayjs from "dayjs";
import { calcularDescuento, calcularExentoGrabado, calcularImpuestos, calcularSubtotal, calcularTotal, calcularTotalImpuestos, templateProducto } from "../../Components/utils";
import { PLAZO_VACIO } from "../../../../utils/plazos";

const Form = ({ ordenActual, isEdit }) => {
	const history = useHistory();

	const formRef = useRef();
    const [loading, setLoading] = useState(true);
    // Al editar, el formulario no se muestra hasta volcar el pedido en él: si
    // no, las filas montan primero con la línea vacía y luego se recargan.
    const [ordenCargada, setOrdenCargada] = useState(!isEdit);

	//Cosas generales como formulario
	const [form, setForm] = useState({
		orden: {},
		numero_orden: {},
		fecha: dayjs().format("YYYY-MM-DD"),
		fecha_vencimiento: dayjs().format("YYYY-MM-DD"),
		notas: "",
		tipo: "cliente",
	});

    const [contactoId, setContactoId] = useState();
    const [facturaProductos, setFacturaProductos] = useState([
        templateProducto(Date.now())
    ]);
    const [plazo, setPlazo] = useState({});
    const [errors, setErrors] = useState({});

	const [showCreateContactoModal, setShowCreateContactoModal] =
		useState(false);
	const [showEditContactoModal, setShowEditContactoModal] = useState(false);
	const [showCancel, setShowCancel] = useState(false);

	// Opciones de los Dropdown
	const [dropdownOptions, setDropdownOptions] = useState({
		contactos: [],
		terminos: [],
		productos: [],
		vendedores: [],
		rutas: [],
		grupos: [],
		impuestos: [],
	});

	const [saving, setSaving] = useState(false);
	const [createButtonClicked, setCreateButtonClicked] = useState("normal");
    const [pinSeguridad, setPinSeguridad] = useState("");

	//Calculos Finales
	const sumatoriaFinal = useMemo(() => ({
        subtotal: calcularSubtotal(facturaProductos),
        descuento: calcularDescuento(facturaProductos),
        impuestos: calcularImpuestos(facturaProductos),
        exentoGrabado: calcularExentoGrabado(facturaProductos),
        total: !isNaN(calcularTotal(facturaProductos)) ? calcularTotal(facturaProductos) : 0,
    }), [facturaProductos]);

    const totalitbis = useMemo(() => calcularTotalImpuestos(facturaProductos), [facturaProductos]);

	//Para llenar inputs de contacto (Cliente)
	const [contactoInfo, setContactoInfo] = useState({});

    const resetFacturaProductos = () => {
        setFacturaProductos([
            templateProducto(Date.now())
        ]);
    }

	const toggleCreateContactoModal = async (e, contacto = null) => {
		if (e) e.preventDefault();
		setShowCreateContactoModal((state) => !state);

		if (!contacto || !Object.keys(contacto).includes("id")) return;

        setContactoId(contacto.id);

		changeContactInfo(contacto.id);
        handleInputChange(undefined, 'direccion_entrega')
	};

	const toggleEditContactoModal = async (e, contacto = null) => {
		if (e) e.preventDefault();
		setShowEditContactoModal((state) => !state);

		if (!contacto || !Object.keys(contacto).includes("id")) return;

		setContactoId(contacto.id);

		changeContactInfo(contacto.id, false);
	};

	const changeContactInfo = (contacto, clear = true) => {
		if (!contacto) return;

		request(`info-contacto/${contacto}`).then(({ data }) => {
			const vendedor = isEdit
				? (ordenActual.vendedor ? { value: ordenActual.vendedor.id, label: `${ordenActual.vendedor.nombre} ${ordenActual.vendedor?.apellido}` } : null)
				: (auth.is("vendedor") || auth.is("vendedor-factura-orden_compra") || auth.is("cobrador") || auth.is('vendedor-cliente')
					? {
							value: auth.getUser().empleado?.id,
							label: `${auth.getUser().empleado?.codigo} ${
								auth.getUser().empleado?.nombre
							} ${auth.getUser().empleado?.apellido}`,
					  }
					: {
							value: data.vendedor?.id,
							label: `${data.vendedor?.codigo} ${data.vendedor?.nombre} ${data.vendedor?.apellido}`,
					  }
				);

			const ruta = isEdit 
				? (ordenActual.ruta ? { value: ordenActual.ruta?.id, label: ordenActual.ruta?.nombre } : null)
				: (data.ruta ? { value: data.ruta.id, label: data.ruta.nombre } : null);
            const contact = {
                ...data,
                vendedor: vendedor?.value ? vendedor : null,
                ruta: ruta,
                credito_disponible_actual: parseFloat(data.credito_disponible),
            };
			setContactoInfo(contact);


            if (clear) {
                changePlazo(PLAZO_VACIO);
                resetFacturaProductos();
            }

            aplicarLimiteFecha();
		});
	};

	const handleInputChange = (value, field) => {
		setForm((form) => ({
			...form,
			[field]: value,
		}));
	};

	const handleDetalleChange = (value, field) => {
		setContactoInfo((state) => ({ ...state, [field]: value }));
	};

	const aplicarLimiteFecha = () => {
		if (!contactoInfo.plazo) return;

		return dayjs(form.fecha)
			.add(contactoInfo.plazo?.dias, "day")
			.format("YYYY-MM-DD");
	};

	// Funciones para traer data de los dropdowns
	const getDropdownData = () => {
		request("ordenes-compra/create?tipo_documento=pedido").then((res) => {
			setDropdownOptions((options) => ({
				...options,
				productos: res.data?.productos.filter(producto => {
                    const almacenes = auth.almacenes();
									
					if (auth.is('super-admin') || auth.is('admin') || almacenes.length === 0) return true;
									
					return almacenes.includes(producto.almacen?.id);
                }),
				rutas: res.data?.rutas,
				terminos: res.data?.terminos,
				impuestos: res.data?.impuestos,
			}));

            setLoading(false);

			if (isEdit) return;

            changePlazo(PLAZO_VACIO);

			setForm((state) => ({
				...state,
				numero_orden: {
					value: res.data.numero_orden?.id,
					label: `${res.data?.numero_orden?.tipo}${res.data?.numero_orden?.numero_siguiente}`,
					fecha_vencimiento:
						res.data?.numero_orden?.fecha_vencimiento,
				},
			}));
		});

		getVendedoresForDropdown().then((data) => {
			setDropdownOptions((options) => ({
				...options,
				vendedores: data.filter((vendedor) => vendedor.value !== ""),
			}));
		});
	};

	const getContactosForDropdown = () => {
		const url = isEdit
			? "contactos?limit=1000"
			: `contactos?limit=1000&tipo=${
					form.tipo === "interna" ? "proveedor" : "cliente"
			  }`;

		request(url).then((res) => {
			const contactos = [];
			const isSaler = isVendedor();

			if (isSaler){
				const vendedor_id = auth.getUser().empleado?.id;

				contactos.push(...res.data.filter(contacto => contacto.vendedor?.id === vendedor_id));
			}

			setDropdownOptions((options) => ({
				...options,
				contactos:
					isSaler
						? contactos.map((contacto) => ({
								value: contacto.id,
								label: contacto.nombre,
						  }))
						: res.data.map((contacto) => ({
								value: contacto.id,
								label: contacto.nombre,
						  })),
			}));
		});
	};

	const updateTotal = (
		id = null,
		subtotal = null,
		total = 0,
		impuestos = 0,
		descuento = 0,
		impuesto,
        productoInfo = {},
	) => {
		setFacturaProductos(prev => prev?.map((producto) => {
            if (producto.id !== id) return producto;

            const updated = {
                ...producto,
                producto_id: productoInfo.id,
                importe: subtotal / producto.cantidad,
                descuento,
                subtotal,
                impuestos,
                precios: productoInfo.precios || [],
                producto: productoInfo.producto || {},
                precio_venta: productoInfo.precio_venta,
                total,
                cantidadAnterior: productoInfo.cantidadAnterior,
                unidad: productoInfo.unidadSeleccionada?.value ?? producto.unidad,
                factor: productoInfo.factor ?? 1,
                unidad_id: productoInfo.unidadSeleccionada?.unidad_id ?? null,
            };

            if (impuesto.value) {
                updated.impuesto = impuesto;
            }

            if (productoInfo.precio_manual || productoInfo.precio_venta) {
                updated.precio_facturado = parseFloat(productoInfo.precio_manual ?? productoInfo.precio_venta?.value);
            }

            return updated;
        }));
	};

	const addProducto = () => {
        setFacturaProductos(prev => [
            ...prev,
            templateProducto(Date.now())
        ])
	};

	const removeProducto = async (index) => {
        setFacturaProductos(prev => prev.filter((i) => i.id !== index));
	};

	const cancel = () => {
		history.push(getLink("/ingresos/pedidos"));
	};

	const guardarYNuevaOrden = async () => {
		await setCreateButtonClicked("nueva");

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

	const guardarYFacturar = async () => {
		await setCreateButtonClicked("facturar");

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

	const guardarYSalir = async () => {
		await setCreateButtonClicked("normal");

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};
	const guardarEImprimir = async () => {
		await setCreateButtonClicked("imprimir");

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

	const createOrden = async (event) => {
		event.preventDefault();

		setErrors({});

		setSaving(true);
		const data = new FormData(event.target);

		const response = await apiRequest(data, "ordenes-compra", "POST");

		if (response.success) {
			toast("Orden creada", "success");
			if (createButtonClicked === "normal") {
				history.push(getLink("/ingresos/pedidos"));
			} else if (createButtonClicked === "imprimir") {
				window.open(
					getLink(`/imprimir/ordenes-compra/${response.data.orden}`)
				);
				history.push(getLink("/ingresos/pedidos"));
			} else if (createButtonClicked === "facturar") {
				localStorage.setItem("fromOrden", JSON.stringify("si"));
				history.push(
					getLink("/ingresos/facturas/crear/") + response.data?.orden
				);
			}
			resetFields();
            getDropdownData();
		}
		if (response.code === 422) {
			// Los errores van a `errors`, que es lo que lee el render: en `form`
			// quedaban muertos y el usuario no veía nada. El toast es para los
			// campos que no tienen mensaje en línea.
			setErrors(response.data.message);
			toast(mensajeDeError(response, "Revise los datos del pedido"), "error");
		} else if (response.code === 400 || response.code === 500) {
			toast(mensajeDeError(response, "Error creando el pedido"), "error");
		}

		setSaving(false);
	};

	const editOrden = async (event) => {
		event.preventDefault();

		setErrors({});

		setSaving(true);
		const data = new FormData(event.target);
		data.append("_method", "put");

		const response = await apiRequest(
			data,
			`ordenes-compra/${ordenActual.id}`,
			"POST"
		);

		if (response.success) {
			toast("Pedido actualizado", "success");
			if (createButtonClicked === "normal") {
				history.push(getLink("/ingresos/pedidos"));
			} else if (createButtonClicked === "imprimir") {
				window.open(
					getLink(`/imprimir/ordenes-compra/${response.data.orden}`)
				);
				history.push(getLink("/ingresos/pedidos"));
			} else if (createButtonClicked === "facturar") {
				localStorage.setItem("fromOrden", JSON.stringify("si"));
				history.push(
					getLink("/ingresos/facturas/crear/") + response.data?.orden
				);
			}
			resetFields();
		}
		if (response.code === 422) {
			setErrors(response.data.message);
			toast(mensajeDeError(response, "Revise los datos del pedido"), "error");
		} else if (response.code === 400 || response.code === 500) {
			toast(mensajeDeError(response, "Error actualizando el pedido"), "error");
		}

		setSaving(false);
	};

	const resetFields = () => {
		setCreateButtonClicked("normal");
		setContactoInfo({});
		setForm({
            numero_orden: {},
			fecha: dayjs().format("YYYY-MM-DD"),
			fecha_vencimiento: dayjs().format("YYYY-MM-DD"),
			notas: "",
		});

        setErrors({});
        setContactoId(null);
        resetFacturaProductos();
        changePlazo(PLAZO_VACIO);
        setPinSeguridad("");

		window.scrollTo(0, 0);
	};

	const toggleCancelModal = () => {
		setShowCancel((state) => !state);
	};

	const cancelOrden = async (ordenID) => {
		setShowCancel((state) => !state);
		setErrors({});

		setSaving(true);

		const response = await apiRequest(
			null,
			`ordenes-compra/${ordenID}`,
			"DELETE"
		);

		if (response.success) {
			toast("Pedido Cancelado", "success");
			history.push(getLink("/ingresos/pedidos"));
			return;
		}
		toast("Error cancelando pedido", "error");

		setSaving(false);
	};

	const setEditInfo = async () => {
		await setContactoInfo({
			...ordenActual.cliente,
			vendedor: ordenActual.vendedor && {
				value: ordenActual.vendedor.id,
				label: `${ordenActual.vendedor?.nombre} ${ordenActual.vendedor?.apellido}`,
			},
			ruta: ordenActual.ruta
				? {
						value: ordenActual.ruta?.id,
						label: ordenActual.ruta?.nombre,
				  }
				: null,
			credito_disponible_actual: ordenActual.cliente?.credito_disponible,
		});

        setFacturaProductos(ordenActual.productos);

        setContactoId(ordenActual.cliente?.id);
        changeContactInfo(ordenActual.cliente?.id, false);

        changePlazo({
            value: ordenActual.plazo?.id || ordenActual.plazo?.value,
            label: ordenActual.plazo?.nombre || ordenActual.plazo?.label,
            dias: ordenActual.plazo?.dias,
        });

		setForm((form) => ({
			...form,
			numero_orden: {
				value: ordenActual.numeracion_id,
				label: ordenActual.numero_comprobante,
			},
			fecha: dayjs(ordenActual.fecha).format("YYYY-MM-DD"),
			fecha_vencimiento: dayjs(ordenActual.fecha_vencimiento).format(
				"YYYY-MM-DD"
			),
			notas: ordenActual.notas,
			tipo: ordenActual.tipo,
			direccion_entrega: ordenActual.direccion_entrega || undefined,
		}));

		setOrdenCargada(true);
	};

    const changePlazo = (plazo) => {
        let vencimiento = dayjs(form.fecha);

        setPlazo(plazo);

        if (form.fecha) {
            if (plazo.dias === null) return;

            vencimiento = vencimiento.add(plazo.dias, "day");

            handleInputChange(
                vencimiento.format("YYYY-MM-DD"),
                "fecha_vencimiento"
            );
        }
    }

    useEffect(() => {
        if (!contactoInfo.credito_disponible_actual) return;
        setContactoInfo(state => ({
            ...state,
            credito_disponible: money(
                state.credito_disponible_actual - (sumatoriaFinal.total - form.prevTotal)
            ),
        }));
    }, [sumatoriaFinal.total, form.prevTotal]);

	useEffect(() => {
        getDropdownData();
	}, []);

	useEffect(() => {
		getContactosForDropdown();
	}, [form.tipo]);

	useEffect(() => {
		if (!isEdit || !ordenActual?.id) return;
		setEditInfo();
	}, [ordenActual, ordenActual.productos]);

    if (loading || !ordenCargada) {
		return <Loader />;
	}

	return (
		<>
			<form
				method="post"
				onSubmit={(e) => {
					isEdit ? editOrden(e) : createOrden(e);
				}}
				ref={formRef}
			>
				<input
					type="hidden"
					name="id"
					value={ordenActual.id}
					onChange={() => {}}
				/>
				<div className="crear-compra">
					<div className="page-controls">
						<Detalles
							form={form}
							contactoInfo={contactoInfo}
                            contactoId={contactoId}
                            setContactoId={setContactoId}
                            plazo={plazo}
                            changePlazo={changePlazo}
							dropdownOptions={dropdownOptions}
							toggleCreateContactoModal={
								toggleCreateContactoModal
							}
                            changeContactInfo={changeContactInfo}
							toggleEditContactoModal={toggleEditContactoModal}
							handleInputChange={handleInputChange}
							aplicarLimiteFecha={aplicarLimiteFecha}
							handleDetalleChange={handleDetalleChange}
							isEdit={isEdit}
							tipoOrden={form.tipo}
                            errors={errors}
						/>
					</div>
					<hr />
					<div className="col-md-12 p-0">
						{window.screen.width <= 992 ? (
							<div className="d-block d-lg-none">
								{facturaProductos &&
									facturaProductos.map(
										(producto, index) => (
											<ProductosOrdenMobile
												key={producto.id}
												producto={producto}
												index={index}
												removeProducto={removeProducto}
												productos={
													dropdownOptions.productos
												}
												updateTotal={updateTotal}
												precioLimite={
													contactoInfo.precio_venta
												}
												banderaContacto={
													contactoInfo.bandera
												}
												impuestosForDropdown={
													dropdownOptions.impuestos
												}
												facturaProductos={
													facturaProductos
												}
												isEdit={isEdit}
												tipoOrden={form.tipo}
												contacto={contactoInfo.id}
                                                errors={errors}
											/>
										)
									)}
								{errors.productos && (
									<small className="help-blockParams form-Text">
										{errors.productos[0]}
									</small>
								)}
								<div className="d-flex justify-content-end mb-3">
									<button
										type="button"
										onClick={addProducto}
										className="btn"
										style={{
											border: "1px solid #FE9D1F",
											color: "#6c757d",
										}}
									>
										<i className="fas fa-plus" /> Agregar
										Producto
									</button>
								</div>

                                {sumatoriaFinal.descuento > 0 && (
                                    <div className="row px-4 justify-content-between">
                                        <strong className="label form-control-label">
                                            Descuento:
                                        </strong>
                                        <span>
                                            -
                                            {formatCurrency(
                                                money(sumatoriaFinal.descuento)
                                            )}
                                        </span>
                                    </div>
                                )}
								<div className="row px-4 justify-content-between">
									<strong className="label form-control-label">
										Subtotal:
									</strong>
									<span>
										{formatCurrency(
											money(sumatoriaFinal.subtotal)
										)}
									</span>
                                    <input
                                        type="hidden"
                                        name="subtotal"
                                        value={sumatoriaFinal.subtotal || 0}
                                        readOnly
                                    />
								</div>
								{Object.keys(sumatoriaFinal.impuestos).map(
									(impuesto, index) => (
										<div
											className="row px-4 justify-content-between"
											key={index}
										>
											<strong className="label form-control-label">
												{impuesto}
											</strong>

											{formatCurrency(
												money(
													sumatoriaFinal.impuestos[
														impuesto
													]
												)
											)}
										</div>
									)
								)}

                                <input
                                    type="hidden"
                                    name="subtotal"
                                    value={sumatoriaFinal.subtotal || 0}
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="impuestos"
                                    value={totalitbis}
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="descuento"
                                    value={
                                        sumatoriaFinal?.descuento || 0
                                    }
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="pagado"
                                    value="0"
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="total"
                                    value={money(sumatoriaFinal.total)}
                                    readOnly
                                />
								<div className="row px-4 justify-content-between">
									<strong className="label form-control-label">
										Total:
									</strong>
									<span>
										{formatCurrency(
											money(sumatoriaFinal.total)
										)}
									</span>
								</div>
							</div>
						) : (
                            <table className="table d-none d-lg-table">
                                <thead>
                                    <tr>
                                        <th width="170px">REF./CÓDIGO</th>
                                        <th width="23%">Descripción</th>
                                        <th width="85px">Cant.</th>
                                        <th width="85px">Unidad</th>
                                        <th width="9%">Importe</th>
                                        <th width="160px">Impuesto</th>
                                        <th width="180px">Precio</th>
                                        <th width="78px">% Desc.</th>
                                        <th className="text-right" width="9%">
                                            Total
                                        </th>
                                        <th className="text-center" width="5%">
                                            Fotos
                                        </th>
                                        <th width="85px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturaProductos &&
                                        facturaProductos.map(
                                            (producto, index) => (
                                                <ProductosOrden
                                                    key={producto.id}
                                                    producto={producto}
                                                    index={index}
                                                    removeProducto={removeProducto}
                                                    productos={
                                                        dropdownOptions.productos
                                                    }
                                                    updateTotal={updateTotal}
                                                    precioLimite={
                                                        contactoInfo.precio_venta
                                                    }
                                                    banderaContacto={
                                                        contactoInfo.bandera
                                                    }
                                                    impuestosForDropdown={
                                                        dropdownOptions.impuestos
                                                    }
                                                    facturaProductos={
                                                        facturaProductos
                                                    }
                                                    isEdit={isEdit}
                                                    tipoOrden={form.tipo}
                                                    errors={errors}
                                                    contacto={contactoInfo.id}
                                                />
                                            )
                                        )}
                                    <tr>
                                        <td
                                            colSpan="11"
                                            style={{ border: 0, paddingTop: 0 }}
                                            className="text-right"
                                        >
                                            <button
                                                type="button"
                                                onClick={addProducto}
                                                className="btn"
                                            >
                                                <i className="fas fa-plus" />{" "}
                                                Agregar Producto
                                            </button>
                                        </td>
                                    </tr>
                                    {sumatoriaFinal?.descuento > 0 && (
                                        <tr>
                                            <td colSpan="9" className="text-right">
                                                <strong className="label form-control-label">
                                                    Descuento:
                                                </strong>
                                            </td>
                                            <td colSpan="2" className="text-right">
                                                - {formatCurrency(
                                                    money(sumatoriaFinal?.descuento)
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td colSpan="9" className="text-right">
                                            <strong className="label form-control-label">
                                                Subtotal:
                                            </strong>
                                        </td>
                                        <td colSpan="2" className="text-right">
                                            <input
                                                type="hidden"
                                                name="subtotal"
                                                value={sumatoriaFinal.subtotal || 0}
                                                readOnly
                                            />
                                            <input
                                                type="hidden"
                                                name="impuestos"
                                                value={totalitbis}
                                                readOnly
                                            />
                                            <input
                                                type="hidden"
                                                name="descuento"
                                                value={
                                                    sumatoriaFinal?.descuento || 0
                                                }
                                                readOnly
                                            />
                                            {formatCurrency(
                                                money(sumatoriaFinal.subtotal)
                                            )}
                                        </td>
                                    </tr>
                                    {sumatoriaFinal?.exentoGrabado?.Exento && Object.keys(sumatoriaFinal.exentoGrabado).filter(k => ['Exento', 'Grabado'].includes(k)).map(
                                        (impuesto, index) => (
                                            <tr key={index}>
                                                <td
                                                    colSpan="9"
                                                    className="text-right"
                                                >
                                                    <strong className="label form-control-label">
                                                        {impuesto}
                                                    </strong>
                                                </td>
                                                <td
                                                    colSpan="2"
                                                    className="text-right"
                                                >
                                                    {formatCurrency(
                                                        money(
                                                            sumatoriaFinal
                                                                .exentoGrabado[impuesto]
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                    {Object.keys(sumatoriaFinal.impuestos).map(
                                        (impuesto, index) => (
                                            <tr key={index}>
                                                <td
                                                    colSpan="9"
                                                    className="text-right"
                                                >
                                                    <strong className="label form-control-label">
                                                        {impuesto}
                                                    </strong>
                                                </td>
                                                <td
                                                    colSpan="2"
                                                    className="text-right"
                                                >
                                                    <input
                                                        type="hidden"
                                                        name={`impuesto-${index}`}
                                                        value={
                                                            sumatoriaFinal
                                                                .impuestos[impuesto]
                                                        }
                                                        readOnly
                                                    />
                                                    {formatCurrency(
                                                        money(
                                                            sumatoriaFinal
                                                                .impuestos[impuesto]
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                    <tr>
                                        <td colSpan="9" className="text-right">
                                            <strong className="label form-control-label">
                                                Total:
                                            </strong>
                                        </td>
                                        <td colSpan="2" className="text-right">
                                            <input
                                                type="hidden"
                                                name="pagado"
                                                value="0"
                                                readOnly
                                            />
                                            <input
                                                type="hidden"
                                                name="total"
                                                value={money(sumatoriaFinal.total)}
                                                readOnly
                                            />
                                            {formatCurrency(
                                                money(sumatoriaFinal.total)
                                            )}
                                        </td>
                                    </tr>
                                    {errors.total && (
                                        <tr>
                                            <td colSpan="11" className="text-right">
                                                <small className="help-blockParams form-Text">
                                                    {errors.total[0]}
                                                </small>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
						<hr />
					</div>

                    <div className="col-md-12 d-none">
                        <table className="table">
                            <thead>
                                <tr>
                                    <td><small>ITBIS 16%</small></td>
                                    <td><small>ITBIS 18%</small></td>
                                    <td><small>GRABADO ITBIS 16%</small></td>
                                    <td><small>GRABADO ITBIS 18%</small></td>
                                    <td><small>EXENTO</small></td>
                                    <td><small>GRABADO</small></td>
                                    <td><small>IMPUESTO TOTAL</small></td>
                                    <td><small>DESCUENTO</small></td>
                                    <td><small>SUBTOTAL</small></td>
                                    <td><small>TOTAL</small></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {money(sumatoriaFinal?.impuestos['ITBIS 16%'])}
                                        <input type="hidden" name="sumatoria[ITBIS 16%]" value={money(sumatoriaFinal?.impuestos['ITBIS 16%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.impuestos['ITBIS 18%'])}
                                        <input type="hidden" name="sumatoria[ITBIS 18%]" value={money(sumatoriaFinal?.impuestos['ITBIS 18%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['ITBIS 16%'])}
                                        <input type="hidden" name="sumatoria[Grabado ITBIS 16%]" value={money(sumatoriaFinal?.exentoGrabado['ITBIS 16%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['ITBIS 18%'])}
                                        <input type="hidden" name="sumatoria[Grabado ITBIS 18%]" value={money(sumatoriaFinal?.exentoGrabado['ITBIS 18%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['Exento'])}
                                        <input type="hidden" name="sumatoria[Exento]" value={money(sumatoriaFinal?.exentoGrabado['Exento'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['Grabado'])}
                                        <input type="hidden" name="sumatoria[Grabado]" value={money(sumatoriaFinal?.exentoGrabado['Grabado'])} />
                                    </td>
                                    <td>
                                        {money(totalitbis)}
                                        <input type="hidden" name="sumatoria[Total ITBIS]" value={money(totalitbis)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.descuento)}
                                        <input type="hidden" name="sumatoria[Descuento]" value={money(sumatoriaFinal.descuento)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.subtotal)}
                                        <input type="hidden" name="sumatoria[Subtotal]" value={money(sumatoriaFinal.subtotal)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.total)}
                                        <input type="hidden" name="sumatoria[Total]" value={money(sumatoriaFinal.total)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

					<div
						className="form-group col-md-12"
						style={{ marginBottom: "0.3rem" }}
					>
						<label className="label form-control-label">
							notas:
						</label>
						<textarea
                            className="text-input form-control"
                            id="notas"
                            name="notas"
                            rows={4}
                            value={form.notas}
                            onChange={e => handleInputChange(e.target.value, 'notas')}
                        />
						{errors.notas && (
							<small className="help-blockParams form-Text">
								{errors.notas[0]}
							</small>
						)}
					</div>
					{form?.direccion_entrega && <div className="form-group col-md-12" style={{ marginBottom: "0.3rem" }}>
						<input type="hidden" name="direccion_entrega[direccion]" value={form.direccion_entrega.direccion} />
						<input type="hidden" name="direccion_entrega[ubicacion]" value={form.direccion_entrega.ubicacion} />

						<label className="label form-control-label">
							Dirección Entrega:
						</label>

						<div style={{ padding: "0.375rem 0.75rem", color: "#495057", backgroundColor: "#fff", border: "ipx solid #ced4da", borderRadius: "0.25rem" }}>
							{form.direccion_entrega.direccion}
						</div>
					</div>}
					{/* DESKTOP FOOTER */}
					<div className="page-footer d-none d-lg-block text-right">
						<button
							type="button"
							onClick={cancel}
							className="btn btn-plain"
						>
							Volver
						</button>
						{saving ? (
							<Loader type="small" />
						) : (
							<>
								{isEdit && (
									<button
										type="button"
										onClick={() => toggleCancelModal()}
										className="btn btn-outline-danger mr-2"
									>
										Cancelar Pedido
									</button>
								)}
								{form.tipo !== "interna" && (
									<button
										type="button"
										onClick={() => guardarYFacturar()}
										className="btn btn-outline-primary mr-2"
									>
										Guardar y facturar
									</button>
								)}
								{!isEdit && (
									<button
										type="button"
										onClick={() => guardarYNuevaOrden()}
										className="btn btn-outline-primary mr-2"
									>
										Guardar y crear nueva
									</button>
								)}
								<button
									type="button"
									onClick={() => guardarYSalir()}
									className="btn btn-outline-primary"
								>
									Guardar
								</button>
								<button
									type="button"
									onClick={() => guardarEImprimir()}
									className="btn btn-primary"
								>
									Guardar e imprimir
								</button>
							</>
						)}
					</div>
					{/* MOBILE FOOTER */}
					<div className="page-footer d-block d-lg-none">
						{!saving && (
							<div className="row justify-content-center">
								<button
									type="button"
									onClick={() => guardarEImprimir()}
									className="btn btn-primary col-11 col-sm-5 mb-2 mb-sm-0"
								>
									Guardar e imprimir
								</button>
								<button
									type="button"
									onClick={() => guardarYSalir()}
									className="btn btn-outline-primary col-11 col-sm-5"
								>
									Guardar
								</button>
							</div>
						)}
						<div className="row justify-content-center">
							{saving ? (
								<Loader type="small" />
							) : (
								<>
									{!isEdit && (
										<button
											type="button"
											onClick={() => guardarYNuevaOrden()}
											className="btn btn-outline-primary col-11 col-sm-5 mt-2"
										>
											Guardar y crear nueva
										</button>
									)}
									{isEdit && (
										<button
											type="button"
											onClick={() => toggleCancelModal()}
											className="btn btn-outline-danger col-11 col-sm-5 mt-2"
										>
											Cancelar Pedido
										</button>
									)}
								</>
							)}
							<button
								type="button"
								onClick={cancel}
								className="btn btn-plain col-11 col-sm-5 mt-2"
							>
								Volver
							</button>
						</div>
					</div>
				</div>
			</form>
			<Modal
				show={showCreateContactoModal}
				blank={true}
				toggle={toggleCreateContactoModal}
				size="lg"
			>
				<Create toggle={toggleCreateContactoModal} fromFacturacion />
			</Modal>
			<Modal
				show={showEditContactoModal}
				blank={true}
				toggle={toggleEditContactoModal}
				size="lg"
			>
				<Edit
					toggle={toggleEditContactoModal}
					contacto={contactoInfo}
					fromFacturacion
				/>
			</Modal>
			<Modal
				title="Cancelar Pedido"
				show={showCancel}
				callback={() => cancelOrden(ordenActual.id)}
				acceptText="Aceptar"
				toggle={toggleCancelModal}
			>
				¿Estás seguro de que deseas cancelar este pedido? (Esta acción no
				se puede deshacer).
			</Modal>
		</>
	);
};

export default Form;
